import React from 'react'
import { useParams } from 'react-router-dom'
import { Box, Card } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { useGetCustomersWalletQuery } from 'hooks/queries/Customers/useGetCustomersWallets'
import { useCustomerCards } from 'pages/Customers/CustomerCard/hooks/useCustomerCards'
import { CardArt } from './CardArt'
import { CardDetailsActions } from './CardDetailsActions'
import { CardDetailsInfo } from './CardDetailsInfo'
import { CardDetailsInfoSkeleton } from './CardDetailsInfoSkeleton'

interface CardDetailsProps {
  onFreeze?: () => void
  onCardDetailsClick?: () => void
}

export const CardDetails: React.FC<CardDetailsProps> = ({ onFreeze, onCardDetailsClick }) => {
  const { id: customerId = '' } = useParams<{ id?: string }>()
  const { card, isLoading: isCardLoading, isError: isCardError } = useCustomerCards(customerId)

  const {
    data: wallet,
    isLoading: isWalletLoading,
    isError: isWalletError,
  } = useGetCustomersWalletQuery(card?.ledger?.id ?? '', !!card?.ledger?.id)

  const isLoading = isCardLoading || isWalletLoading
  const isError = isCardError || isWalletError

  if (isLoading) {
    return (
      <Card variant="static" full>
        <Box flex align="center" justify="between" gap={16} className="flex-wrap">
          <Box flex align="center" gap={16} className="flex-shrink-0">
            <CardArt />
            <CardDetailsInfoSkeleton />
          </Box>

          <CardDetailsActions
            card={undefined}
            onFreeze={onFreeze}
            onCardDetailsClick={onCardDetailsClick}
          />
        </Box>
      </Card>
    )
  }

  if (isError || !card || !wallet) {
    return <RequestErrorStatusCard />
  }

  return (
    <Card variant="static" full>
      <Box flex align="center" justify="between" gap={16} className="flex-wrap">
        <Box flex align="center" gap={16} className="flex-shrink-0">
          <CardArt />
          <CardDetailsInfo card={card} wallet={wallet} />
        </Box>

        <CardDetailsActions
          card={card}
          onFreeze={onFreeze}
          onCardDetailsClick={onCardDetailsClick}
        />
      </Box>
    </Card>
  )
}
